'use strict'; /* eslint-disable no-console */

const showMore = (function() {

	const onClass = 'js-show-more-on';
	const activeClass = 'js-show-more-active';
	const videosClass = 'video-content';
	const photosClass = 'photo-content';
	const smallerWidgetClass = 'widget--small';
	const largerWidgetClass = 'widget--large';
	let contentArr = {};

	/*
	 * showLessInit - called inside an array.forEach function
	 *
	 * @param item: instance of an show-more group
	 * @param index: current index of forEach
	 */
	function showLessInit(item, id) {
		const trigger = item.querySelector('.js-show-more-trigger');
		const content = item.querySelector('.js-show-more-content');
		let contentMinHeight;

		// Clear height
		content.style.maxHeight = '';

		const contentMaxHeight = content.offsetHeight;

		switch (true) {
			case content.classList.contains(videosClass) || content.classList.contains(photosClass):
				contentMinHeight = content.querySelector('li').scrollHeight * 2;
				break;
			case content.classList.contains(largerWidgetClass):
				contentMinHeight = content.querySelector('.card__item').scrollHeight * 2;
				break;
			default:
				contentMinHeight = content.querySelector('.card__item').scrollHeight
				break;
		}

		// Store content heights for hiding & showing
		contentArr[id] = {
			maxHeight: contentMaxHeight,
			minHeight: contentMinHeight,
		};

		showLess(content, trigger);
	}

	function showMore(el, trigger) {
		const id = trigger.id;
		let labelLess = "Show less -";
		el.classList.add(activeClass);
		el.style.maxHeight = contentArr[id].maxHeight;
		trigger.innerHTML = labelLess;
	}

	function showLess(el, trigger) {
		if (!trigger) {
			return;
		}

		const id = trigger.id;
		let labelMore = "Show more +";
		el.classList.remove(activeClass);
		el.style.maxHeight = contentArr[id].minHeight - 4;
		trigger.innerHTML = labelMore;
	}

	/*
	 * Toggle function to show/hide an accordion item
	 *
	 * @param e: click event
	 */
	function toggle(e) {
		e.preventDefault();

		const triggerEl = e.currentTarget;
		const contentSelector = triggerEl.getAttribute('data-target');
		const contentEl = document.getElementById(contentSelector);

		if (!contentEl.classList.contains(activeClass)) {
			showMore(contentEl, triggerEl);
		} else {
			showLess(contentEl, triggerEl);
		}
	}

	/*
	 * Init - called inside an array.forEach function
	 *
	 * @param item: instance of an show-more group
	 * @param index: current index of forEach
	 */
	function init(item, index) {
		const none = document.createElement('div')
		const trigger = item.querySelector('.js-show-more-trigger') || none;
		const content = item.querySelector('.js-show-more-content') || none;
		const childCount = content.children.length;
		let childCountLimit = 4;

		trigger.id = `js-show-more-trigger-${index}`;
		trigger.setAttribute('data-target', `js-show-more-content-${index}`);
		content.id = `js-show-more-content-${index}`;
		content.setAttribute('data-show-more', index);

		switch (true) {
			case content.classList.contains(largerWidgetClass):
				childCountLimit = 6;
				break;
			case content.classList.contains(smallerWidgetClass):
				childCountLimit = 3;
				break;
			default:
				childCountLimit;
				break;
		}

		if(childCount > childCountLimit) {
			item.classList.add(onClass);
			showLessInit(item, trigger.id);

			trigger.removeEventListener('click', toggle);
			trigger.addEventListener('click', toggle);
		} else {
			item.classList.remove(onClass);
			trigger.style.display = 'none';
		}
	}

	/*
	 * Event listener called by default
	 */
	window.addEventListener('DOMContentLoaded', () => {
		const elements = document.querySelectorAll('.js-show-more');

		[].forEach.call(elements, (item,index) => {
			init(item, index);
		});
	});

	/*
	 * Event listener called by window resize
	 */
	window.addEventListener('resize', () => {
		const elements = document.querySelectorAll('.js-show-more');

		[].forEach.call(elements, (item,index) => {
			init(item, index);
		});
	});

})();

export default showMore;



// WEBPACK FOOTER //
// ./resources/assets/js/show-more.js